export const privilegeDefinitions = [
  {
    title: "Access Claim Template Builder",
    description:
      "This privilege allows a user to create, edit, and manage claim templates within the system. Users without this privilege will not be able to access or modify any claim templates and will see those sections disabled or hidden in the UI.",
  },
  {
    title: "Access Living Facility Builder",
    description:
      "This privilege allows the user to access and manage the Living Facility Builder, a tool for creating and maintaining data related to living facilities (e.g., nursing homes, assisted living). This includes defining attributes like facility name, address, etc.",
  },
  {
    title: "Access NDM Reporting",
    description:
      "This privilege allows users to utilize the NDM Data Smasher tool. This tool enables users to upload CSV files containing patient data and process them for inclusion into the system. The feature will automatically map the data from the CSV file to the appropriate fields in the patient records, allowing for efficient bulk creation of new patients in the system.",
  },
  {
    title: "Access Pricing Table",
    description:
      "This privilege allows a user to view, edit, and manage pricing tables used for patient billing and service cost tracking. Users without this privilege will not be able to access pricing-related screens or make changes to pricing data.",
  },
  {
    title: "Access Program Management",
    description:
      "This privilege allows the user to access and manage the Program Management feature, including creating, transferring, and viewing patients associated with published programs. Users without this privilege will not see the Program Management card or any related functionality in the Settings list.",
  },
  {
    title: "Access Reporting",
    description:
      "This privilege provides the user with the ability to view and interact with system reports. Users can generate reports to monitor and evaluate key metrics across the system.",
  },
  {
    title: "Access Resource Catalog",
    description:
      "This privilege allows users to access the Resource Catalog, a centralized repository for documents, templates, guides, and other resources used by the system's users. This can include training materials, healthcare documentation, and policy resources.",
  },
  {
    title: "Build Questionnaire",
    description:
      "Users with this privilege can create, edit, and manage questionnaires within the system. Questionnaires might be used for gathering patient data, feedback, or other types of forms related to healthcare services.",
  },
  {
    title: "Bulk Patient Upload",
    description:
      "This privilege grants the user the ability to upload large datasets of patient information in bulk to the system. Typically used for onboarding or migrating patient data in bulk from external systems. Users with this privilege can access the bulk upload feature in the system's patient management section.",
  },
  {
    title: "Edit Provider Organization Associations",
    description:
      "This privilege allows users to modify or update the provider's association with organizations. This can include linking providers to specific organizations or changing which organizations they are affiliated with.",
  },
  {
    title: "Edit Provider Personal Information",
    description:
      "Users with this privilege can update or edit a provider's personal information, including their contact details. This is often used to keep provider information up to date within the system.",
  },
  {
    title: "Invite New Patient",
    description:
      "This privilege grants users the ability to add new patients into the system.",
  },
  {
    title: "Invite New Provider",
    description:
      "This privilege grants users the ability to add new providers into the system.",
  },
  {
    title: "Sign Encounter Note",
    description:
      "This privilege controls whether a user can sign encounter notes. Users with this privilege can create, pend, and sign encounter notes as normal. Users without this privilege can only pend notes and cannot sign them. This supports new provider account types and ensures proper oversight by licensed providers.",
  },
];
